import Vue from "vue"

// สลิปต้องล็อกอินถึงจะเปิดได้ (backend ย้าย image-preview เข้า auth แล้ว)
// <img src> / <a href> ส่ง Bearer token ไม่ได้ → โหลดผ่าน this.$axios เป็น blob แล้วใช้ object URL แทน
// โหลดไม่ได้ (ไม่มีสิทธิ์/ไฟล์หาย) คืน '' ให้หน้าจอโชว์ชื่อไฟล์ไปตามเดิม
export async function loadSlipUrl(url) {
  try {
    const res = await Vue.prototype.$axios.get(url, { responseType: "blob", validateStatus: (s) => s === 200 })
    return URL.createObjectURL(res.data)
  } catch (e) {
    return ""
  }
}

// คืนหน่วยความจำของ object URL ที่สร้างไว้ (เรียกตอนปิด drawer / โหลดชุดใหม่)
export function revokeSlipUrls(list) {
  (list || []).forEach((item) => {
    if (item && typeof item.path === "string" && item.path.indexOf("blob:") === 0) {
      URL.revokeObjectURL(item.path)
    }
  })
}
